import classes from "./stage2.module.css";
import Button from "../../../components/UI/Button/button";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { INDUSTRY_SUGGESTIONS } from "../../../constants";
import { errorHandler } from "../../../utils";
import { companyInfoType, companyProfile } from "../../../services/clientCalls";
import PanelHero from "../PanelHero/PanelHero";
import {
  IconAlertCircle,
  IconCategory,
  IconChevronsLeft,
  IconUsers,
} from "@tabler/icons-react";
import { TagSearchInput } from "../../../components/UI/TagsInput/tags";
import s from "../steps.module.css";
import { Select } from "../../../components/UI/FormInput/input";

const SIZE_LABELS = [
  "1 - 10 employees",
  "10 - 50 employees",
  "50 - 200 employees",
  "200 - 500 employees",
  "500 - 1,000 employees",
  "1,000 - 10,000 employees",
  "100k +",
];

const COMPANY_TYPES = [
  "Individual",
  "Company",
];

const Stage2 = () => {
  const navigate = useNavigate();
  const [industry, setIndustry] = useState([]);
  const [range, setRange] = useState("1");
  const [load, setLoad] = useState(false);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({});
  const [type, setType] = useState(undefined);
  const [errors, setErrors] = useState({});

  const sliderPct = (range / 6) * 100;
  const sliderBg = `linear-gradient(to right, var(--ob-amber) ${sliderPct}%, var(--ob-border) ${sliderPct}%)`;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getCompanyProfile = async () => {
    setLoader(true);
    try {
      const res = await companyProfile();
      setData(res.data.data.client);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => {
    getCompanyProfile();
  }, []);

  useEffect(() => {
    if (data?.companyType) {
      setType(data?.companyType);
    }
    if (data?.industry) {
      setIndustry(data?.industry);
    }
    if (data?.companySize) {
      setRange(data?.companySize);
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate())
      try {
        setLoad(true);
        const res = await companyInfoType({
          industry: industry,
          companyType: type,
          companySize: range,
          completedCompanyType: "Yes",
        });

        if (type === "Registered")
          navigate({
            pathname: "/client-onboarding",
            search: "stage=3",
            state: "registered",
          });
        else
          navigate({
            pathname: "/client-onboarding",
            search: "stage=3",
            state: "not-registered",
          });
        setLoad(false);
      } catch (error) {
        setLoad(false);
        error?.response?.data
          ? errorHandler(error?.response?.data?.errors, "Error")
          : errorHandler(
              "Network error: Something went wrong, Please check your internet connection and try again.",
              "Error",
            );
      }
  };

  const validate = () => {
    const errs = {};
    if (!type) errs.type = "Please select a company type.";
    if (!industry.length)
      errs.industry = "Please select at least one industry.";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  return (
    <>
      <div className={classes.container}>
        <PanelHero
          icon={<IconCategory />}
          title="Company Type"
          subtitle="Please provide us with basic information about your company"
        />

        <form>
          <div className={s.panelBody}>
            {/* Company Size — slider */}
            <div style={{ marginBottom: 24 }}>
              <div className={s.sliderRow}>
                <span className={s.sectionLabel} style={{ marginBottom: 0 }}>
                  Company Size
                  <span style={{ color: "#dc2626", marginLeft: 2 }}>*</span>
                </span>
                <span className={s.sliderSizeVal}>
                  <IconUsers size={12} /> {SIZE_LABELS[range]}
                </span>
              </div>
              <input
                type="range"
                className={s.sizeSlider}
                min={0}
                max={6}
                step={1}
                value={range}
                style={{ background: sliderBg }}
                onChange={(e) => setRange(+e.target.value)}
              />
              <div className={s.sliderEndLabel}>100k +</div>
            </div>

            {/* Company Type */}
            <div style={{ marginBottom: 24 }}>
              <Select
                label="Company Type"
                labelVariant="uppercase"
                required
                value={type}
                onChange={(e) => {
                  setType(e.target.value);
                  setErrors((prev) => ({ ...prev, type: "" }));
                }}
                error={errors.type}
                shake={errors.type}
              >
                <option value="">Select company type…</option>
                {COMPANY_TYPES.map((t) => (
                  <option key={t}>{t}</option>
                ))}
              </Select>
            </div>

            {/* Industry multi-select */}
            <div>
              <div className={s.sectionLabel}>
                Industry
                <span style={{ color: "#dc2626", marginLeft: 2 }}>*</span>
              </div>
              <TagSearchInput
                selected={industry}
                onChange={(inds) => {
                  setIndustry(inds);
                  setErrors((prev) => ({ ...prev, industry: "" }));
                }}
                suggestions={INDUSTRY_SUGGESTIONS}
                placeholder="Type to search or add an industry…"
                hasError={!!errors.industry}
                shake={errors.industry}
              />

              {errors.industry && (
                <div className="text-[11px] text-[#dc2626] font-medium flex items-center gap-1 mt-1.5">
                  <IconAlertCircle size={13} />
                  {errors.industry}
                </div>
              )}
            </div>
          </div>

          <div className={s.panelFooter}>
            <div className={s.footerNote}>
              <Button
                variant="ghost"
                leftIcon={<IconChevronsLeft />}
                onClick={() => navigate(-1)}
                disabled={load}
              >
                Back
              </Button>
            </div>
            <div className={s.footerActions}>
              <Button onClick={handleSubmit} disabled={load} loading={load}>
                Next
              </Button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
export default Stage2;
